import { render, staticRenderFns } from "./editAddressModal.vue?vue&type=template&id=0152b26a&scoped=true&"
import script from "./editAddressModal.vue?vue&type=script&lang=js&"
export * from "./editAddressModal.vue?vue&type=script&lang=js&"
import style0 from "./editAddressModal.vue?vue&type=style&index=0&id=0152b26a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0152b26a",
  null
  
)

export default component.exports